<template>
  <div class="telegram-preview-card">
    <div class="telegram-preview-header">
      <div class="telegram-preview-brand">
        <button type="button" class="telegram-preview-back"><i class="fas fa-chevron-left" /></button>
        <span class="telegram-preview-avatar">ED</span>
        <div>
          <strong>Ecosave Delivery <i class="fas fa-shield-alt" /></strong>
          <small>bot</small>
        </div>
      </div>
      <span class="telegram-preview-pill">{{ $t('telegramMessage.preview') }}</span>
    </div>
    <div class="telegram-preview-body">
      <div class="telegram-date-pill">Today</div>
      <div class="telegram-chat-row">
        <div :class="['telegram-message-bubble', hasImage ? 'has-media' : 'text-only']">
          <div v-if="hasImage" class="telegram-preview-media-frame">
            <img class="telegram-preview-image" :src="imagePreview" :alt="messageTitle">
          </div>
          <div class="telegram-message-content">
            <strong v-if="messageTitle" class="telegram-message-title">{{ messageTitle }}</strong>
            <p class="telegram-message-text">{{ messageContent }}</p>
            <span class="telegram-preview-time">14:32 <i class="fas fa-check-double" /></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TelegramMessagePreview',
  props: {
    model: { type: Object, required: true },
    imagePreview: { type: String, default: null }
  },
  computed: {
    hasImage () {
      return Boolean(this.imagePreview)
    },
    messageTitle () {
      return this.model.title || this.$t('telegramMessage.titlePlaceholder')
    },
    messageContent () {
      return this.model.content || this.$t('telegramMessage.defaultPreviewContent')
    }
  }
}
</script>

<style scoped>
.telegram-preview-card { background: #fff; border: 1px solid #dbe4ee; border-radius: 12px; box-shadow: 0 12px 30px rgba(45, 55, 72, .10); display: flex; flex-direction: column; min-height: 100%; overflow: hidden; position: sticky; top: 18px; width: 100%; }
.telegram-preview-header { align-items: center; background: #27a9e0; color: white; display: flex; justify-content: space-between; min-height: 46px; padding: 8px 12px; }
.telegram-preview-brand { align-items: center; display: flex; gap: 8px; min-width: 0; }
.telegram-preview-back { background: transparent; border: 0; color: rgba(255,255,255,.85); padding: 0 3px; }
.telegram-preview-avatar { align-items: center; background: rgba(255,255,255,.22); border: 1px solid rgba(255,255,255,.35); border-radius: 50%; display: flex; flex: 0 0 28px; font-size: 10px; height: 28px; justify-content: center; width: 28px; }
.telegram-preview-brand strong, .telegram-preview-brand small { display: block; line-height: 1.2; }
.telegram-preview-brand strong { font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.telegram-preview-brand strong i { color: #fcd34d; font-size: 8px; }
.telegram-preview-brand small { font-size: 10px; opacity: .82; }
.telegram-preview-pill { background: rgba(255,255,255,.2); border-radius: 999px; flex: 0 0 auto; font-size: 10px; padding: 3px 7px; text-transform: uppercase; }
.telegram-preview-body { background-color: #e7eef3 !important; background-image: radial-gradient(rgba(148,163,184,.28) .8px, transparent .8px); background-size: 8px 8px; flex: 1 1 auto; margin: 0; min-height: calc(100vh - 210px); overflow-y: auto; padding: 16px; }
.telegram-date-pill { background: rgba(100,116,139,.28); border-radius: 999px; color: #fff; display: block; font-size: 11px; font-weight: 600; margin: 0 auto 14px; padding: 4px 12px; width: max-content; }
.telegram-chat-row { display: flex; justify-content: center; }
.telegram-message-bubble { background: #d9fdd3; border-radius: 12px; box-shadow: 0 1px 2px rgba(15,23,42,.12); max-width: 86%; min-width: 96px; overflow: hidden; position: relative; width: max-content; }
.telegram-message-bubble.has-media { min-width: 220px; padding: 4px; width: 320px; }
.telegram-message-bubble.text-only { padding: 8px 10px 6px; }
.telegram-preview-media-frame { align-items: center; background: #111827; border-radius: 9px 9px 6px 6px; display: flex; height: 220px; justify-content: center; overflow: hidden; width: 100%; }
.telegram-preview-image { display: block; height: 100%; max-width: 100%; object-fit: contain; width: 100%; }
.telegram-message-content { color: #0f172a; font-size: 13px; line-height: 1.45; overflow-wrap: anywhere; padding: 7px 8px 5px; white-space: pre-line; }
.telegram-message-bubble.text-only .telegram-message-content { padding: 0; }
.telegram-message-title { display: block; font-size: 13px; font-weight: 700; line-height: 1.35; margin: 0 0 4px; }
.telegram-message-text { color: #1f2937; font-size: 13px; line-height: 1.48; margin: 0; min-height: 17px; padding-right: 56px; white-space: pre-line; }
.telegram-message-bubble.has-media .telegram-message-text { padding-right: 0; }
.telegram-preview-time { color: #5f8f57; float: right; font-size: 10px; line-height: 1; margin-left: 8px; margin-top: -12px; position: relative; }
.telegram-preview-time i { color: #3b82f6; margin-left: 3px; }
@media (max-width: 575px) {
  .telegram-preview-body { min-height: 280px; padding: 12px; }
  .telegram-message-bubble { max-width: 92%; }
  .telegram-message-bubble.has-media { min-width: 0; width: 92%; }
  .telegram-preview-media-frame { height: 190px; }
}
</style>
